import React, { Component, PropTypes } from 'react';
import { List, ListItem } from 'components/List';
import { Colors, Units } from 'Css';
import { FormattedDate } from 'react-intl';
import Thumb from './Thumb';

const css = oxygenCss({
  date: {
    color: Colors.minBlack
  },
  thumb: {
    flex: '0 0 64px'
  },
  body: {
    padding: `0 ${Units.base}px`,
    flex: '1 0 auto'
  }
});

class FileSelectorList extends Component {
  static propTypes = {
    items: PropTypes.array,
    changeDir: PropTypes.func,
    onSelect: PropTypes.func
  };

  handleTouchTap = item => {
    const { type, id } = item;
    if (type === 'dir') {
      const { changeDir } = this.props;
      changeDir(id);
    } else {
      const { onSelect } = this.props;
      onSelect && onSelect(item);
    }
  };

  render() {
    const { items } = this.props;
    return (
      <List>
        {items.map(item => {
          const { id, created, type, url } = item;
          const createdTime =
            (created && created.split(' ').join('T') + 'Z') || null;
          return (
            <ListItem key={id} payload={item} onTouchTap={this.handleTouchTap}>
              <div className={css.thumb}>
                <Thumb type={type} url={url} />
              </div>
              <div className={css.body}>
                <div>{item.name}</div>
                <div className={css.date}>
                  {(createdTime && (
                    <FormattedDate value={new Date(createdTime)} />
                  )) ||
                    ''}
                </div>
              </div>
            </ListItem>
          );
        })}
      </List>
    );
  }
}

export default FileSelectorList;



// WEBPACK FOOTER //
// ./src/js/components/MediaLibrary/FileSelectorList.js